<template>
  <div class="kurir">
    <div class="flex justify-between items-center pb-6 shadow-border-b mdmax:shadow-none mdmax:flex-col">
      <div class="flex-1 mdmax:flex-auto mdmax:w-full mdmax:mb-2">
        <LinkButton buttonText="Tambah User" url="/user/create" linkType="internal" :size="isMobile ? 'full' : 'regular'" />
      </div>
      <div class="flex-1 flex justify-end gap-8 mdmax:flex-auto mdmax:w-full mdmax:flex-col mdmax:gap-2">
        <div class="w-2/5 mdmax:w-full">
          <label class="text-base text-neutral-700 font-medium mb-1 inline-block">Role</label>
          <CustomSelect :options="roleList" v-model="selectedRole" :defaultValue="selectedRole" placeholder="Pilih role" optionLabel="name" />
        </div>
        <div class="w-3/5 mdmax:w-full">
          <label class="text-base text-neutral-700 font-medium mb-1 inline-block">Pencarian</label>
          <div class="relative">
            <TextField type="text" :withIcon="true" v-model="searchTerm" placeholder="Pencarian nama, ID, email role" @enter="doSearch()" />
            <div class="absolute left-3 top-1/2 transform -translate-y-1/2">
              <Search />
            </div>
          </div>
        </div>
      </div>
    </div>
    <TableComponent :columns="columns" :list="filteredData">
      <template slot="table-row" slot-scope="{ entry, column }">
        <LinkButton v-if="column.field === 'action'" buttonText="Lihat rincian" :url="`/user/detail/${entry.id}`" linkType="internal" type="secondary" size="small" />
        <span v-else>{{ entry[column.field] || '-' }}</span>
      </template>
    </TableComponent>
    <div class="text-neutral-500 font-medium mt-2 text-sm" v-if="!isMobile">Menampilkan {{ start }} - {{ end }} dari {{ totalRecords }}</div>
    <div class="mt-8 flex justify-center items-center mb-6" v-if="filteredData && filteredData.length > 0">
      <pagination :currentPage="currentPage" :totalCount="totalRecords" :pageSize="pageSize" @onPageChange="onPageChange" />
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  components: {
    CustomSelect: () => import(/* webpackChunkName: "Forms" */ '@/components/Forms/CustomSelect'),
    TextField: () => import(/* webpackChunkName: "Forms" */ '@/components/Forms/TextField'),
    LinkButton: () => import(/* webpackChunkName: "Forms" */ '@/components/Forms/LinkButton'),
    Search: () => import(/* webpackChunkName: "icon" */ '@/components/Icons/Search'),
    Pagination: () => import(/* webpackChunkName: "Pagination" */ '@/components/Pagination/Pagination'),
    TableComponent: () => import(/* webpackChunkName: "Table" */ '@/components/Table/Table')
  },
  data: () => ({
    selectedRole: '',
    columns: [
      // { label: 'ID', field: 'id' },
      { label: 'Nama', field: 'name' },
      { label: 'No Handphone', field: 'phone_number' },
      { label: 'Role', field: 'role' },
      { label: 'Email', field: 'email' },
      { label: 'Action', field: 'action' }
    ],
    searchTerm: '',
    totalRecords: 0,
    currentPage: 1,
    pageSize: 10,
    hasMorePages: true
  }),
  computed: {
    ...mapGetters('role', ['roleList']),
    ...mapGetters('admin', ['admins']),
    ...mapGetters('common', ['isMobile']),
    ...mapGetters('auth', ['userData']),
    filteredData() {
      let temp = this.admins || []
      temp = temp.filter(item => {
        return item.id !== ''
      })
      return temp
    },
    start() {
      return (this.currentPage - 1) * this.pageSize + 1
    },
    end() {
      const lastOnPage = (this.currentPage - 1) * this.pageSize + this.pageSize
      return lastOnPage > this.totalRecords ? this.totalRecords : lastOnPage
    }
  },
  methods: {
    ...mapActions('role', ['getRoleList']),
    ...mapActions('admin', ['getAdmin']),
    ...mapActions('common', ['showLoading', 'hideLoading']),
    doSearch() {
      this.getUser(this.searchTerm)
    },
    getUser(searchTerm = '') {
      this.showLoading()
      const partnerId = this.userData?.user?.group_id
      this.getAdmin({
        partnerId: partnerId,
        params: {
          page: this.currentPage,
          per_page: this.pageSize,
          search_keyword: searchTerm,
          sort: 'DESC',
          partner_id: partnerId
        }
      })
        .then(res => {
          this.totalRecords = res.data.meta.total_item
          this.hideLoading()
        })
        .catch(() => {
          this.hideLoading()
        })
    },
    getRole() {
      this.getRoleList({
        params: {
          page: 1,
          per_page: 50,
          search_keyword: ''
        }
      })
        .then(res => {
          this.hideLoading()
        })
        .catch(() => {
          this.hideLoading()
        })
    },
    onPageChange(page) {
      this.currentPage = page
      this.$router.push({ path: '/armada', query: { page: page } })
    }
  },
  created() {
    this.getRole()
    if (!this.$route.query.page) {
      this.$router.push({ path: '/user', query: { page: 1 } })
      this.page = 1
      this.currentPage = 1
    } else {
      this.page = parseInt(this.$route.query.page)
      this.currentPage = parseInt(this.$route.query.page)
      this.getUser()
    }
  },
  watch: {
    $route(val) {
      if (val.query.page) {
        this.page = parseInt(val.query.page)
        this.currentPage = parseInt(val.query.page)
        this.getUser()
      } else {
        this.$router.push({ path: '/user', query: { page: 1 } })
        this.page = 1
        this.currentPage = 1
      }
    }
  }
}
</script>
